import '@fontsource/monoton';
import '@fontsource/roboto-condensed';
import '@fontsource/share';

import {useEffect, useState} from "react";
import {Outlet, Route, Routes} from 'react-router-dom';
import {Box, Stack, Toolbar, Typography} from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";

import theme from './components/globalComponents/Theme'
import CssBaseline from "@mui/material/CssBaseline";
import { NavBar } from "./components/globalComponents/NavBar";

import {postSession} from "./utils/api";
import Home from "./components/pageComponents/home/Home"
import Plot1d from "./components/pageComponents/plot1d/Plot1d";
import Plot2d from "./components/pageComponents/plot2d/Plot2d";
import DataProducts from "./components/pageComponents/dataProducts/DataProducts";
import SpacecraftMapping from "./components/pageComponents/spacecraftMapping/SpacecraftMapping";
import TimeSeries from "./components/pageComponents/timeSeries/TimeSeries";
import Coronagraphs from "./components/pageComponents/coronagraphs/Coronagraphs";
import WhiteLight from "./components/pageComponents/whiteLight/WhiteLight";
import Error from "./components/pageComponents/errorPage/Error";
import {Footer} from "./components/globalComponents/Footer";
import Euv from "./components/pageComponents/euv/Euv";
import EuvComparison from "./components/pageComponents/euvComparison/EuvComparison";
import DataAccessPage from "./components/pageComponents/dataAccess/DataAccessPage";
import {References} from "./components/pageComponents/resources/References";
import {About} from "./components/pageComponents/resources/About";
import ApiDocs from "./components/pageComponents/resources/ApiDocs";
import {ContactUs} from "./components/pageComponents/contactPage/ContactUs";

function LayoutWithHeader() {
  return (
    <>
      <NavBar />
      <Toolbar />
      <Box component="main" sx={{ flex: 1, minHeight: 0, p: 0, pb: 10 }}>
        <Outlet />
      </Box>
      <Footer />
    </>
  );
}

function App() {
  const [id, setId] = useState(localStorage.getItem("id") || 'none')
  return (
    <>
      <ThemeProvider theme={theme}>
        <CssBaseline />
          <Routes>
            <Route path="/mhdweb2" element={<Home />} />
            <Route element={<LayoutWithHeader />}>
              <Route path="/mhdweb2/tools/plot1d" element={<Plot1d id={id} setId={setId}/>} />
              <Route path="/mhdweb2/tools/plot2d" element={<Plot2d id={id} setId={setId}/>} />
              <Route path="/mhdweb2/tools/data-products" element={<DataProducts id={id} setId={setId}/>} />
              <Route path="/mhdweb2/tools/spacecraft-mapping" element={<SpacecraftMapping id={id} setId={setId}/>} />
              <Route path="/mhdweb2/tools/time-series" element={<TimeSeries id={id} setId={setId}/>} />
              <Route path="/mhdweb2/tools/coronagraphs" element={<Coronagraphs id={id} setId={setId}/>} />
              <Route path="/mhdweb2/tools/white-light" element={<WhiteLight id={id} setId={setId}/>} />
              <Route path="/mhdweb2/tools/euv" element={<Euv id={id} setId={setId}/>} />
              <Route path="/mhdweb2/tools/euv-comparison" element={<EuvComparison id={id} setId={setId}/>} />
              <Route path="/mhdweb2/tools/data-access" element={<DataAccessPage id={id} setId={setId}/>} />
              <Route path="mhdweb2/references" element={<References />} />
              <Route path="mhdweb2/about" element={<About />} />
              <Route path="mhdweb2/api" element={<ApiDocs />} />
              {/*<Route path="mhdweb2/contact" element={<ContactUs />} />*/}
              <Route path="/500" element={<Error displayCode={500} displayStatus={"SERVER ERROR"} />} />
              <Route path="*" element={<Error displayCode={404} displayStatus={"PAGE NOT FOUND"} />} />
            </Route>
          </Routes>
      </ThemeProvider>
    </>
  );
}

export default App;
